import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';
import { TimeIntervalType } from '@/components/modules/Metrics/shared/types/TimeIntervalType';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';

export const useTimeIntervalLabel = (timeInterval: TimeInterval): string => {
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { language },
  } = useConfigContext();

  const formatDay = (date: Date) =>
    new Intl.DateTimeFormat(language, { day: 'numeric', month: 'short', year: 'numeric' }).format(date);

  if (timeInterval.type === TimeIntervalType.MONTH_TO_DATE) {
    const month = new Intl.DateTimeFormat(language, { month: 'long' }).format(timeInterval.current.start);
    return getTextIdTranslation('METRICS_PERIOD_MONTH_TO_DATE')
      .replace('$v1', `${month.charAt(0).toLocaleUpperCase()}${month.slice(1)}`)
      .replace('$v2', String(timeInterval.current.start.getFullYear()))
      .replace('$v3', String(timeInterval.current.end.getDate()));
  }

  if (timeInterval.type === TimeIntervalType.CUSTOM) {
    return getTextIdTranslation('METRICS_PERIOD_CUSTOM')
      .replace('$v1', formatDay(timeInterval.current.start))
      .replace('$v2', formatDay(timeInterval.current.end));
  }

  return getTextIdTranslation(timeInterval.type);
};
